// Set up Intercom chat widget
// https://developers.intercom.com/installing-intercom/docs/basic-javascript

declare global {
  interface Window {
    Intercom?: any
    intercomSettings?: any
    attachEvent?: any
  }
}

const runIntercomScript = (INTERCOM_APP_ID: string) => {
  ;(function () {
    const w = window
    const ic = w.Intercom
    if (typeof ic === 'function') {
      ic('reattach_activator')
      ic('update', w.intercomSettings)
    } else {
      const d = document
      const i = function () {
        // @ts-ignore
        i.c(arguments)
      }
      // @ts-ignore
      i.q = []
      // @ts-ignore
      i.c = function (args) {
        // @ts-ignore
        i.q.push(args)
      }
      w.Intercom = i
      const l = function () {
        const s = d.createElement('script')
        s.type = 'text/javascript'
        s.async = true
        s.src = `https://widget.intercom.io/widget/${  INTERCOM_APP_ID}`
        const x = d.getElementsByTagName('script')[0]
        // @ts-ignore
        x.parentNode.insertBefore(s, x)
      }
      if (document.readyState === 'complete') {
        l()
      } else if (w.attachEvent) {
        w.attachEvent('onload', l)
      } else {
        w.addEventListener('load', l, false)
      }
    }
  })()
}

export const initialiseIntercom = ({
  INTERCOM_APP_ID,
  INTERCOM_HASH,
  user,
  home,
}: {
  INTERCOM_APP_ID: string
  INTERCOM_HASH: string
  user: {
    id: string
    name: {
      first?: string
      last?: string
    }
  }
  home?: {
    id: string
    name: string
  }
}) => {
  // Warning: don't change syntax. needs to be 'var' and ';' at eol
  runIntercomScript(INTERCOM_APP_ID)
  window.Intercom('boot', {
    app_id: INTERCOM_APP_ID,
    user_id: user.id,
    user_hash: INTERCOM_HASH,
    name: `${user.name.first || ''} ${user.name.last || ''}`,
    company: home && {
      id: home.id,
      name: home.name,
    },
  })

  if (window.location.pathname !== '/') {
    window.Intercom('update', { hide_default_launcher: true })
  }
}

export const showIntercom = () =>
  window.Intercom && window.Intercom('update', { hide_default_launcher: false })
export const hideIntercom = () =>
  window.Intercom && window.Intercom('update', { hide_default_launcher: true })
export const trackEvent = (eventName: string) =>
  window.Intercom && window.Intercom('trackEvent', eventName)

export default initialiseIntercom
